import { Input } from "@/core/components/ui/input";
import { Stack } from "@/core/components/ui/stack";
import type { ApPoLineItem } from "@/accounts-payable/types";
import { SectionLabel } from "./shared";

/**
 * Line items as one list: description full width, quantity + unit cost side
 * by side, a divider between items — the view mode's list, not a card each.
 */
export const LineItemsEditor = ({
  items,
  onChange,
}: {
  items: ApPoLineItem[];
  onChange: (index: number, key: keyof ApPoLineItem, value: string) => void;
}) => (
  <Stack gap="sm" fullWidth>
    <SectionLabel>Line items ({items.length})</SectionLabel>
    <Stack gap="none" fullWidth className="divide-y divide-stroke-secondary">
      {items.map((it, i) => (
        <Stack key={i} gap="sm" fullWidth className="py-3 first:pt-0 last:pb-0">
          <Input
            label="Description"
            value={it.description}
            onChange={(e) => onChange(i, "description", e.target.value)}
            fullWidth
          />
          <Stack direction="row" gap="md" fullWidth>
            <Input
              label="Quantity"
              type="text"
              inputMode="numeric"
              value={it.quantity}
              onChange={(e) => onChange(i, "quantity", e.target.value)}
              fullWidth
            />
            <Input
              label="Unit cost ($)"
              type="text"
              inputMode="decimal"
              value={it.unit_cost}
              onChange={(e) => onChange(i, "unit_cost", e.target.value)}
              fullWidth
            />
          </Stack>
        </Stack>
      ))}
    </Stack>
  </Stack>
);
